import React, { useEffect } from 'react';
import { cubicBezier, Gauge } from "gauge-chart-js";
const gradstop = require("gradstop");

const GaugeChartSentiment = ({parentToChild}) => {

  const {percent, uniqueId, uniqueClass, uniqueLabelId, uniqueLabelClass, chartTitle, handleException, handleExceptionUnit} = parentToChild;

  useEffect(() => {
    const fromAngle = 220;
    const toAngle = 500;
    const maxValue = toAngle - fromAngle;
    let value = maxValue * percent;
    // let updatedPercent = (value / maxValue) * 100;

    const element = document.querySelector(uniqueLabelId);
    element.innerHTML = parseInt(percent*10).toString();

    const container = document.querySelector(uniqueId);
    const sharedConfig = {
      lineWidth: 4,
      container,
      fromAngle,
      toAngle,
      easing: cubicBezier(0.165, 0.84, 0.44, 1)
    };

    const gaugeBackground = new Gauge({
      ...sharedConfig,
      color: "#f5f5f5"
    });
    gaugeBackground.setValue(maxValue);

    const gaugeMain = new Gauge({
      ...sharedConfig,
      colors: gradstop({
        stops: maxValue,
        colorArray: ["#FF0000", "#ffe600", "#70ad47", "#008631"]
      })
    });
    gaugeMain.setValue(value);
  }, [percent, uniqueId, uniqueClass, uniqueLabelId, uniqueLabelClass, chartTitle]);

  return (
    <div>
      <div className={`${uniqueClass} gauge-gauge`}></div>
      <div className={`${uniqueLabelClass} ${handleException} sentiment-label`}></div>
      <div className={`gauge-sentiment-unit ${handleExceptionUnit}`}>/10</div>
      <div className='gauge-chart-title'>{chartTitle}</div>
    </div>
  );
};

export default GaugeChartSentiment;
